// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ContentBlockProps {
    img?: {
        srcSmall?: [string, number]
        srcMedium?: [string, number]
        srcLarge?: [string, number]
        src: string
        alt: string
    }
    title?: string
    text?: string
}

export default function ContentBlock({
    img,
    title,
    text
}: ContentBlockProps) {
    return (
        <div className='content-block'>

            <div className={clsx(
                'content-block__image',
                !img?.src && 'content-block__image--no-image'
            )}>
                {isNonWhitespaceString(img?.src) && (
                    <Image
                        srcSmall={img.srcSmall}
                        srcMedium={img.srcMedium}
                        srcLarge={img.srcLarge}
                        src={img.src}
                        alt={img.alt}
                        className='cover'
                    />
                )}
            </div>

            <div className='content-block__content'>

                {isNonWhitespaceString(title) && (
                    <h3 className='title'>
                        {title}
                    </h3>
                )}

                {isNonWhitespaceString(text) && (
                    <div
                        className='text'
                        dangerouslySetInnerHTML={{ __html: text }}
                        suppressHydrationWarning
                    />
                )}

            </div>

        </div>
    )
}

